// eslint-disable-next-line import/no-cycle
import {
  WidgetTypeConfig,
  ConfigurationPanelStructureItemEnum,
} from '@/types';
// eslint-disable-next-line import/no-cycle
import getJavascriptContent from '@/components/template-builder/getters/javascript';
// eslint-disable-next-line import/no-cycle
import setJavascriptContent from '@/components/template-builder/setters/javascript';
// eslint-disable-next-line import/no-cycle
import getConditionsAndRepetitionGroup from '@/components/template-builder/config/fields/conditions-repetition-group-helper';
// eslint-disable-next-line import/no-cycle
import getCodeFieldConfig from '@/components/template-builder/config/fields/code-config';
// eslint-disable-next-line import/no-cycle
import variables from '@/components/template-builder/utils/variables-list';

const widgetJavascriptConfig: WidgetTypeConfig = {
  tabPanel: {
    label: 'templateBuilder.widgetsHeaders.javascript',
    items: [
      {
        type: ConfigurationPanelStructureItemEnum.FIELDS_GROUP,
        label: 'templateBuilder.configs.widgetConfiguration',
        selector: 'body #spm_body #{ID}',
        items: [
          {
            label: 'templateBuilder.fields.javascriptCode',
            selector: '{SELECTOR}.spm_widget_display_javascript script',
            properties: [{ name: 'content', getter: getJavascriptContent, setters: [setJavascriptContent] }],
            ...getCodeFieldConfig('', true, variables.allVariables, false, 'javascript'),
          },
        ],
      },
      getConditionsAndRepetitionGroup('body #spm_body #{ID}', { includeLoop: false }),
    ],
  },
};

export default widgetJavascriptConfig;
